import script from "./TressDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./TressDropdown.vue?vue&type=style&index=0&id=0b2e546a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2e546a"]])

export default __exports__